import request from '@/router/axios';
export const businessnoticeList = (current, size, params, search) => {
  return request({
    url: `/api/businessnotice/workList`,
    method: "post",
    data: {
      current,
      size,
      ...params,
      ...search,
    },
  });
};
